export default __webpack_public_path__ + "static/media/icon-algowork-n@2x.7f5f04c5.webp";